import PropTypes from "prop-types";

// Layouts
import SimpleDoubleChecking from "../Buttons/SimpleDoubleChecking";

// MUI
import { Box, Stack, SvgIcon, Typography } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as TrashIcon } from "@/assets/icons/actions/trash.svg";

export default function RoundBoxDeletable(props) {
	const {
		children,
		additionalComponent,
		containerProps = {
			sx: { minWidth: "455px", width: "455px" },
		},
		innerProps = {
			className: "!border !border-solid !border-disabled rounded-[10px]",
		},
		headerProps = {
			direction: "row",
			position: "relative",
			justifyContent: "space-between",
			alignItems: "center",
			pl: "24px",
			style: { minHeight: "45px" },
			sx: null,
		},
		title = "",
		titleTop = null,
		titleProps = {
			className: "tiered-title",
		},
		deletable = false,
		deleteDisabled = false,
		confirmationDeleteSx = {
			right: "6px !important",
		},
		sx = null,
		containerChildProps = {
			px: "24px",
		},
		onDeleteAction = () => {},
	} = props;

	return (
		<Box {...containerProps}>
			<Box {...innerProps} sx={{ minHeight: 100, ...sx }}>
				<Stack {...headerProps}>
					<Stack {...titleTop} overflow={"hidden"} whiteSpace={"nowrap"}>
						<Typography {...titleProps}>{title}</Typography>
					</Stack>
					<Stack {...headerProps}>
						{additionalComponent}
						{deletable && (
							<Stack {...titleTop} pt={"3px"} pr={"16px"}>
								<SimpleDoubleChecking
									className={"btn-delete integer-input-delete"}
									color={"var(--gray-blue-color)"}
									confirmationButtonColor={"var(--gray-blue-color)"}
									disabled={deleteDisabled}
									icon={<CloseRoundedIcon fontSize="medium" />}
									iconHover={<CloseRoundedIcon fontSize="medium" />}
									confirmationIcon={
										<SvgIcon
											className="[&>path]:fill-gray-blue !text-gray-blue !text-[18px] !ml-[1px]"
											component={TrashIcon}
											viewBox={"0 0 14 14"}
											color={"primary"}
										/>
									}
									confirmationSx={confirmationDeleteSx}
									onDeleteAction={onDeleteAction}
								/>
							</Stack>
						)}
					</Stack>
				</Stack>

				<Stack {...containerChildProps}>{children}</Stack>
			</Box>
		</Box>
	);
}
RoundBoxDeletable.propTypes = {
	children: PropTypes.node,
	additionalComponent: PropTypes.node,
	containerProps: PropTypes.object,
	innerProps: PropTypes.object,
	headerProps: PropTypes.object,
	title: PropTypes.string,
	titleTop: PropTypes.object,
	titleProps: PropTypes.object,
	deletable: PropTypes.bool,
	deleteDisabled: PropTypes.bool,
	deleteTitle: PropTypes.string,
	confirmationDeleteSx: PropTypes.object,
	mainDeleteSx: PropTypes.object,
	deleteProps: PropTypes.object,
	sx: PropTypes.object,
	containerChildProps: PropTypes.object,
	onDeleteAction: PropTypes.func,
};
